var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "appSettingsSyncRoot",
      attrs: { role: "dialog", "aria-labelledby": "appSettingsSyncTitle" },
    },
    [
      _c("div", { staticClass: "titleBar" }, [
        _c(
          "div",
          {
            staticClass: "title",
            attrs: { id: "appSettingsSyncTitle", role: "alert" },
          },
          [
            _vm._v(
              "AppSettings Sync: " +
                _vm._s(_vm.release.Name) +
                " @ " +
                _vm._s(_vm.environment.Name)
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dialogBody" },
        [
          _vm.release.AppSettingsDiffs.length
            ? [
                _vm._l(
                  _vm.release.AppSettingsDiffs,
                  function (appSettingsDiff, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "diffSection" },
                      [
                        _c("p", [
                          _vm._v(
                            'Diff between "' +
                              _vm._s(appSettingsDiff.FirstAgentName) +
                              '" and "' +
                              _vm._s(appSettingsDiff.SecondAgentName) +
                              '":'
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "htmlDiff",
                          domProps: {
                            innerHTML: _vm._s(appSettingsDiff.HtmlDiff),
                          },
                        }),
                      ]
                    )
                  }
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Select an Agent to apply their AppSettings to all:"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.agentAppSettingsList, function (agent, index) {
                  return _c(
                    "div",
                    { key: agent.name, staticClass: "agentSelectContainer" },
                    [
                      _c("slide-button", {
                        key:
                          "slideBtn_appSettingsSync_" +
                          index +
                          "_" +
                          _vm.slideBtnCounter,
                        attrs: {
                          "auto-width": false,
                          circle: true,
                          disabled: false,
                          noanimate: true,
                          width: 300,
                          height: 60,
                          text: agent.name,
                          "success-text": "selecting",
                          requireReleaseToComplete: true,
                        },
                        on: {
                          completed: function ($event) {
                            return _vm.onSelectCommanded(agent.appSettings)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
              ]
            : _c("p", [_vm._v("This release's AppSettings are in sync.")]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "div",
          {
            ref: "closeBtn",
            staticClass: "dialogButton",
            attrs: { tabindex: "0" },
            on: {
              click: _vm.DefaultClose,
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ]) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.DefaultClose.apply(null, arguments)
              },
            },
          },
          [_vm._v("\n\t\t\tClose\n\t\t")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }